module.exports = __webpack_public_path__ + "static/img/0010-4未启用吉林市人民政府.011fa28.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0010-4未启用吉林市人民政府.jpg
// module id = +ZBU
// module chunks = 0